<template>
  <div>
    <div v-if="authenticatedUser">
    <b-container class="mt-lg-3">
      <div class="mt-lg-5">
        <div class="row bg-white mb-4 pt-4 border-custom-lgr">
          <div class="col-lg-5 col-sm-5 col-md-6 col-xs-12">
            <div class="text-left p-3">
          <span>
            <font-awesome-icon icon="user" size=10x>
            </font-awesome-icon>
          </span>
              <br>
              <br>
              <br>
              <span title="Date created" v-b-tooltip.hover.bottom class="text-muted">
            <font-awesome-icon icon="calendar-alt"/> {{ this.user.created | utcLocalDatetime }}
          </span>
            </div>
          </div>

          <div class="col-lg-7 col-sm-7 col-md-6 col-xs-12">
            <div class="p-3 text-left">
              <h3 class="mb-5">
                {{ this.user.name }}
                <small>
                    <router-link :to="{ name: 'accountEdit', params: { id: user.id } }">
                    <b-button title="Edit your account" v-b-tooltip.hover.bottom class="btn btn-sm">
                      <font-awesome-icon icon="edit" size="sm"/>
                      Edit
                    </b-button>
                  </router-link>
                  <b-button title="Delete your account." v-b-tooltip.hover.bottom @click.prevent="showMsgDelete(user.id)"
                            class="btn btn-sm btn-danger">
                    <font-awesome-icon icon="trash-alt" size="sm"/>
                    Delete Account
                  </b-button>
                </small>
              </h3>

              <b-row>
                <b-col>
                  <p>
                    <span title="Name" v-b-tooltip.hover.left class="mr-5">
                      <font-awesome-icon icon="address-book"/> {{ this.user.name }}
                    </span>
                  </p>

                  <p title="Surname" v-b-tooltip.hover.left v-show="this.user.surname">
                    <font-awesome-icon icon="at"/>
                    {{ this.user.surname }}
                  </p>

                  <p title="Username" v-b-tooltip.hover.left class="mr-5">
                    <font-awesome-icon icon="signature"/>
                    {{ this.user.login }}
                  </p>
                </b-col>

                <b-col>
                  <p>
                <span title="Email" v-b-tooltip.hover.left class="mr-5">
                  <font-awesome-icon icon="at"/> {{ this.user.email }}
                </span>
                  </p>

                  <p title="Google ID" v-b-tooltip.hover.left v-show="this.user.googleId" class="mr-5">
                    <!--                    <font-awesome-icon icon="at"/>-->
                    <img src="../images/google.jpg" alt="" style="width: 18px; height: 18px"> {{ this.user.googleId }}
                  </p>
                </b-col>

              </b-row>

            </div>
          </div>
        </div>

      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import NoAccess from '../components/NoAccess'
import Footer from '../components/Footer'

export default {
  name: 'AccountView',
  data () {
    return {
      user: {}
    }
  },
  beforeCreate () {
    this.$store.dispatch('getUser')
      .then(response => {
        this.user = response
      })
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  methods: {
    showMsgSuccess () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('User successfully deleted.', {
        okVariant: 'success'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.$router.push({name: 'home'})
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    showMsgDelete (resId) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('All your data are going to be deleted.', {
        title: 'Are you sure you want to delete your account?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteUser(resId)
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    initUser () {
      this.user = {}
    },
    getUser: function () {
      axios.get('/user/', {withCredentials: true}).then(
        response => {
          this.initUser()
          this.user = response.data
        })
    },
    deleteUser: function (userId) {
      let url = '/user/' + userId
      return axios.delete(url, {withCredentials: true}).then(
        response => {
          if (response.status === 200) {
            this.showMsgSuccess()
            this.$store.dispatch('logout')
          } else {
          }
        }
      )
    }
  },
  components: {
    NoAccess,
    Footer
  }
}
</script>

<style scoped>
  .border-custom-lgr {
    border: 1px solid #d3d3d366;
  }
</style>



// WEBPACK FOOTER //
// src/views/AccountView.vue